import React from 'react';
import { DefaultVariantCoverage } from './DefaultVariantCoverage';
import { ModernVariantCoverage } from './ModernVariantCoverage';
import type { CoverageSectionProps } from './CoverageShared';

export type { CoverageSectionVariant, CarCoverage, Coverage, CoverageSectionProps } from './CoverageShared';
export {
  CoverageItemTitleText,
  CoverageItemDescriptionText,
  StyledPill,
  StyledSection,
  StyledTitle,
  Subtitle,
} from './CoverageShared';

export const CoverageSection = React.forwardRef<HTMLDivElement, CoverageSectionProps>(
  ({ variant = 'default', ...props }, ref) => {
    if (variant === 'modern') {
      return <ModernVariantCoverage ref={ref} {...props} />;
    }

    return <DefaultVariantCoverage ref={ref} {...props} />;
  },
);
